import React from 'react'
import { Skeleton, useContainerWidth } from '@fs/zion-ui'

const Horizontal = () => {
  const atWidth = useContainerWidth()

  return (
    <div>
      <Skeleton.Image
        height={atWidth({
          default: 150,
          sm: 200,
          md: 400,
        })}
      />
      <div>
        <Skeleton.H1 />
        <Skeleton.Button />
      </div>
    </div>
  )
}

const Vertical = () => {
  const atWidth = useContainerWidth()

  return (
    <div>
      <Skeleton.H1 />
      <Skeleton.Image
        height={atWidth({
          default: 150,
          sm: 200,
          md: 400,
        })}
      />
      <Skeleton.Button />
    </div>
  )
}

export default function YouAreNotAloneSkeleton() {
  const atWidth = useContainerWidth()
  const cSize = atWidth({
    default: '150px',
    sm: '150px',
    md: '250px',
    lg: '400px',
  })

  return (
    <div data-testid="YouAreNotAloneSkeleton">
      {atWidth({
        default: <Vertical />,
        md: <Horizontal size={cSize} />,
      })}
    </div>
  )
}
